export class PontosVendaVersaoModel {
    constructor(
        public versao: string = '',
        public dAtualizacao: Date = new Date(),
    ) { }
}